import React from 'react';
import { type DiscountCodeValidationProps } from '../../context';
import {
    StyeldPromoCodeRemoveIcon,
    PromoCodeDescriptionLabel,
    PromoCodeLabel,
    PromoCodeDescription,
    PromoCodeDescriptionSpan,
    StyledPromoCodeCheckIcon,
    StyledPromoCodeErrorIcon,
} from './PromoCodeValidation';

const DiscountCodeValidation = (props: DiscountCodeValidationProps) => {
    const {
        removePromoCode,
        promoCode,
        promoCodeAmount,
        removeGiftVoucher,
        giftVoucher,
        giftVoucherAmount,
        discountCodeError,
    } = props;

    return (
        <>
            {discountCodeError && (
                <PromoCodeDescriptionSpan error>
                    <StyledPromoCodeErrorIcon />
                    {discountCodeError}
                </PromoCodeDescriptionSpan>
            )}
            {promoCode && promoCode.promoType.__typename === 'DiscountPromoType' && (
                <>
                    <PromoCodeDescription>
                        <PromoCodeLabel>
                            <span>{promoCode.promoCode}</span>
                            <StyeldPromoCodeRemoveIcon onClick={removePromoCode} />
                        </PromoCodeLabel>
                        <PromoCodeDescriptionLabel>{promoCodeAmount}</PromoCodeDescriptionLabel>
                    </PromoCodeDescription>

                    <PromoCodeDescriptionSpan success>
                        <StyledPromoCodeCheckIcon />
                        {promoCode.promoType.description}
                    </PromoCodeDescriptionSpan>
                </>
            )}
            {promoCode && promoCode.promoType.__typename === 'GiftPromoType' && (
                <PromoCodeDescriptionSpan success>
                    <StyledPromoCodeCheckIcon />
                    {promoCode.promoType.description}
                </PromoCodeDescriptionSpan>
            )}
            {giftVoucher && (
                <PromoCodeDescription>
                    <PromoCodeLabel>
                        <span>{giftVoucher.giftCode}</span>
                        <StyeldPromoCodeRemoveIcon onClick={removeGiftVoucher} />
                    </PromoCodeLabel>
                    <PromoCodeDescriptionLabel>{giftVoucherAmount}</PromoCodeDescriptionLabel>
                </PromoCodeDescription>
            )}
        </>
    );
};
export default DiscountCodeValidation;
